<template>
    <div class="container">
        <div v-if="selected === undefined" class="bubble">
            <img src="@/assets/Stage/Game/game1/bubble.png" alt="" />
        </div>
        <div v-if="selected === undefined && image" class="question">
            <img :src="imgUrl" alt="" />
        </div>
        <div v-if="selected !== undefined" class="reaction">
            <div class="static-label">
                <span v-if="correct" class="correct">
                    {{ correctText }}
                </span>
                <span v-if="incorrect" class="incorrect">
                    {{ incorrectText }}
                </span>
            </div>
            <div class="hint">
                {{ hint }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        image: String,
        hint: String,
        selected: Number,
        answer: Number,
    },
    computed: {
        imgUrl() {
            const IMAGE_URL = `${process.env.VUE_APP_API_URL}${this.image}`;
            return IMAGE_URL;
        },
        correctText() {
            const RANDOM = Math.floor(this.hint.length + Math.random() * 2) % 2;
            return RANDOM ? '答對了！' : '你好棒！';
        },
        incorrectText() {
            const RANDOM = Math.floor(this.hint.length + Math.random() * 2) % 2;
            return RANDOM ? '再接再厲！' : '哇！你答錯囉！';
        },
        correct() {
            return this.selected === this.answer;
        },
        incorrect() {
            return this.selected !== this.answer;
        },
    },
};
</script>

<style lang="scss" scoped>
.container {
    position: relative;
    width: 90%;
    margin: 0 auto;
    flex: 1;
    min-height: 130px;
    transform: translateY(60px);
    @media screen and (max-height: 670px) {
        transform: translateY(30px);
    }
}
.correct {
    color: #5ac892;
}
.incorrect {
    color: #cf6300;
}
.bubble {
    height: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    > img {
        height: 100%;
        display: block;
        margin: auto;
    }
}
.question {
    height: 70%;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, 10%);
    > img {
        height: 100%;
        display: block;
        margin: auto;
    }
}
.reaction {
    border: 1px solid #979797;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    border-radius: 7px;
    padding: 20px;
    .static-label {
        font-size: 22px;
        margin-bottom: 10px;
    }
    .hint {
        font-size: 26px;
        color: #4d4d4d;
        text-align:justify;
    }
}
</style>
